import { render } from "./NavigationStatementMenu.vue?vue&type=template&id=4c283424&scoped=true&ts=true&lang=pug"
import script from "./NavigationStatementMenu.vue?vue&type=script&lang=ts"
export * from "./NavigationStatementMenu.vue?vue&type=script&lang=ts"

import "./NavigationStatementMenu.vue?vue&type=style&index=0&id=4c283424&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c283424"]])

export default __exports__